module.exports = __webpack_public_path__ + "static/media/pending-approval.d4ed144d.svg";